import React, { useEffect, useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import './RecoverApplications.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { BsSave } from 'react-icons/bs'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link, useNavigate } from 'react-router-dom'

export const RecoverApplications = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  const [getData, setGetData] = useState([])
  const [admins, setAdmins] = useState(false)
  const [error, setError] = useState()
  const token = localStorage.getItem('token')
  const [users, setUsers] = useState([])

  const getUsers = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchUsers', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setUsers(res.data.data)
      })
      .catch((err) => {})
  }
  // fetch all the deleted applications/users(Hr,Admin,Interviewer)
  const deletedData = async (role) => {
    var userRole = role ? role : 23

    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchDeletedData',
        {
          id: userRole,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        setGetData(response.data.data)
        setError('')
      })
      .catch((error) => {
        if (error.response.data.totalApplications === 0) {
          setError('There are no records to display')
        }
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }
  useEffect(() => {
    getUsers()
    deletedData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // withdraw deleted application/user(Hr,Admin,Interviewer)
  const withdrawData = async (id) => {
    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/recoverFormData',

        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  // columns to dispplay data of application in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.designation}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Applied date',
      cell: (row) => {
        return (
          <Tippy content={row.applied_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {moment(row.applied_date).format('DD-MM-YYYY')}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },
    {
      name: 'HR Status',
      selector: (row) => row.status_hr,
      sortable: true,
      width: '110px',
    },
    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '130px',
    },
    {
      name: 'Final Status',
      cell: (row) => {
        return (
          <Tippy content={row.final_status} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.final_status}
            </p>
          </Tippy>
        )
      },

      width: '110px',
    },
    {
      name: 'Interviewer Name',
      cell: (row) => {
        return (
          <Tippy content={row.interviewer_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.interviewer_name}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Action',
      cell: (row) => {
        return (
          <Tippy content="Recover Application" theme="bootstrap">
            <p>
              <BsSave
                style={{ color: 'blue', cursor: 'pointer' }}
                onClick={() => {
                  withdrawData(row.uuid)
                }}
              />
            </p>
          </Tippy>
        )
      },
    },
  ]

  // columns to dispplay data of user(HR,Admin,Interviewer) in table
  const columns2 = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.name}
            </p>
          </Tippy>
        )
      },

      width: '200px',
    },

    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      width: '300px',
    },
    {
      name: 'Role',
      selector: (row) => row.role,
      sortable: true,
      width: '250px',
    },
    {
      name: 'Contact',
      selector: (row) => row.contact,
      sortable: true,
      width: '200px',
    },
  ]
  return (
    <>
      <Sidebar />

      <div className="container  p-4">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Deleted Users
              </li>
            </ol>
          </nav>
        </div>
        <div className="recover p-4">
          <div className="row">
            <h5 className="col-md text-primary">
              {admins ? 'Deleted Users' : 'Deleted Applications'}
            </h5>
            <div className="mb-3" style={{ width: '20%' }}>
              <div className="col-md form-floating">
                <select
                  className="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="role"
                  onChange={(e) => {
                    deletedData(e.target.value)
                    if (e.target.value === 23) {
                      setAdmins(false)
                    } else {
                      setAdmins(true)
                    }
                  }}
                >
                  {users?.map((i, index) => {
                    return (
                      <option value={i.id} key={index}>
                        {i.name}
                      </option>
                    )
                  })}
                  {/* <option value="Candidates" selected>
                    Candidates
                  </option>
                  <option value="Admin">Admin</option>
                  <option value="HR">HR</option>
                  <option value="Interviewer">Interviewer</option> */}
                </select>
                <label for="floatingSelect">Select Users</label>
              </div>
            </div>
          </div>

          {error ? (
            <span>{error}</span>
          ) : (
            <DataTable
              columns={admins === true ? columns2 : columns}
              data={getData}
              pagination
              highlightOnHover
            />
          )}
        </div>
      </div>
    </>
  )
}
